import React from 'react';
import { Form, Input, Row, SonForm, SubmitButton, useForm } from '../../../_lib/Form2';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { Hint } from '../../../_lib/components/Hint';

function MaxFileSizeConfigEdit({ form }: { form: SonForm<any> }) {
  const { t } = useSonTranslation('MaxFileSizeConfig');
  const { formProps, params, fetchState } = useForm({ form });

  return (
    <Form {...formProps}>
      <Row>
        <Hint message={t('hint')} />
      </Row>
      <Row>
        <Input label={t('headline')} param={params.getByName('son_portal_maxFileUploadSizeMb')} />
      </Row>
      <SubmitButton
        buttonLabel={t('Form:save')}
        messageSuccess={t('Form:status.success')}
        messageSending={t('Form:status.sending')}
        messageFail={t('Form:status.fail')}
        fetchState={fetchState}
        active={fetchState.type !== 'loading' && fetchState.type !== 'success'}
      />
    </Form>
  );
}

export const MaxFileSizeConfigEditView = asFetchableView(MaxFileSizeConfigEdit);
